import moment from 'moment';
import genererGuid from '@/services/general/genererGuid';

export function genererLigneEcheancier() {
  return {
    id: genererGuid(),
    dateDebut: null,
    dateFin: null,
    datePrevisionnelleFacturation: null,
    facturationFaite: false,
    facture: null,
    factreId: null,
    montant: 0,
    tiersId: null,
    fromGeneration: true,
    commentaireFacturation: null,
  };
}

export function genererLigneEcheancierForAuto() {
  return {
    commentaireFacturation: null,
    dateDebut: moment(),
    dateFin: moment(),
    datePrevisionnelleFacturation: moment(),
  };
}
